<template>
  <div class="table-responsive">
    <table class="table table-hover table-striped table-sm mb-0" v-if="results != null && results.rows.length > 0">
      <thead>
        <th v-for="(column, columnIndex) in results.columns" :key="columnIndex" :style="columnStyle(column)">
          <a href="#" class="text-dark" v-on:click.stop.prevent="selectSortOrder(columnIndex)">
            {{column.name}}
            <span v-if="columnIndex === sortColumnIndex">
              <icon v-if="sortDirection === 'ascending'" name="sort_up" :size="11"></icon>
              <icon v-if="sortDirection === 'descending'" name="sort_down" :size="11"></icon>
            </span>
          </a>
        </th>
      </thead>
      <tbody>
        <tr v-for="(row, rowIndex) in results.rows" :key="rowIndex" :style="rowStyle(row)" v-on:click="selectRow(row)">
          <td v-for="(column, columnIndex) in results.columns" :key="columnIndex">
            {{row[column.key]}}
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else="true" class="m-3">
      <b-alert variant="warning" show>No data found for the selected options</b-alert>
    </div>
  </div>
</template>


<script>
import Icon from '@/components/Icon'
import _ from 'lodash'

export default {
  name: 'ReportTable',
  props: ['results', 'report'],
  components: { Icon },
  data () {
    return {}
  },
  computed: {
    sortColumnIndex () {
      return _.findIndex(this.report.columns, (col) => { return this.columnsAreEqual(col, this.sortColumn) })
    },
    sortColumn () {
      return this.report.settings.order[0]
    },
    sortDirection () {
      return this.sortColumn.direction
    },
    oppositeDirection () {
      if (this.sortDirection === 'ascending') {
        return 'descending'
      } else {
        return 'ascending'
      }
    }
  },
  watch: {
  },
  methods: {
    selectSortOrder (columnIndex) {
      if (columnIndex === this.sortColumnIndex) {
        this.sortColumn.direction = this.oppositeDirection
      } else {
        this.report.settings.order = [_.assign(_.cloneDeep(this.report.columns[columnIndex]), {direction: 'ascending'})]
      }
      this.$emit('reorder', this.report)
    },
    columnStyle (column) {
      return { minWidth: `${column.heading_width}px` }
    },
    columnsAreEqual (columnA, columnB) {
      if (columnA.column_id !== columnB.column_id) {
        return false
      }
      if ((columnA.sub_columns == null || columnA.sub_columns.length === 0) && (columnB.sub_columns == null || columnB.sub_columns.length === 0)) {
        return true
      }
      if (columnA.sub_columns.length !== columnB.sub_columns.length) {
        return false
      }
      for (var i = 0; i < columnA.sub_columns.length; i++) {
        if (!this.columnsAreEqual(columnA.sub_columns[i], columnB.sub_columns[i])) {
          return false
        }
      }
      return true
    },
    rowStyle (row) {
      if (row.link) {
        return { cursor: 'pointer' }
      } else {
        return {}
      }
    },
    selectRow (row) {
      this.$emit('selectRow', row)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ReportTable.vue